/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import { ISegmentConfigData } from './type';

const useService = () => {
	const [isActive, setIsActive] = React.useState<{ id: boolean; label: string }>({ id: true, label: 'TEST' });
	const [segmentList, setSegmentList] = React.useState<string[]>(['segment1']);
	const [expDetailsList, setExpDetailsList] = React.useState<
		{
			expName: string;
			bucketDetails: { name: string; share: number }[];
		}[]
	>([
		{
			expName: 'exp1',
			bucketDetails: [
				{
					name: 'control',
					share: 50
				}
			]
		}
	]);
	const { postData } = useContext(AjaxContext);
	const getCTDConfigData = useCallback(
		async ({
			app,
			pageDetails,
			sortDetails,
			filterDetails
		}: {
			app: any;
			pageDetails: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const response = await postData({
				endpoint: '/marketing/dashboard/finance/getCTDConfigs',
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				},
				queryParams: {
					appName
				}
			});
			const listData = formatListData(response?.data?.data?.segmentsConfig);
			const count = response?.data?.data?.segmentsConfig?.length;
			const globalCoolOfPeriod = response?.data?.data?.globalCoolOfPeriod;
			if (globalCoolOfPeriod) setIsActive({ id: true, label: 'ENABLED' });
			else setIsActive({ id: false, label: 'DISABLED' });
			const segmentListFromResponse: string[] = response?.data?.data?.segmentExpDetails?.segmentList;
			const expDetailsListFromResponse = response?.data?.data?.segmentExpDetails?.expDetailsList;
			setSegmentList(segmentListFromResponse);
			setExpDetailsList(expDetailsListFromResponse);
			return { rowCount: count, data: listData, globalCoolOfPeriod };
		},
		[]
	);

	const requestCreateConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		const dataList = [];
		dataList.push(data);
		return postData({
			endpoint: '/marketing/dashboard/finance/createCTDConfigs',
			body: { ctdConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: '/marketing/dashboard/finance/updateCTDConfigs',
			body: { ctdConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableGlobalCoolOffFlag = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: '/marketing/dashboard/finance/updateCTDConfigs',
			body: { toggleGlobalCoolOfPeriod: true, ctdConfigs: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestDisableConfig = useCallback((appName: string, data: ISegmentConfigData) => {
		return postData({
			endpoint: '/marketing/dashboard/finance/removeCTDConfigs',
			body: { segmentName: data.segmentName },
			queryParams: {
				appName
			}
		});
	}, []);

	const toggleIsDisabledField = useCallback(async (rowData: any, history: any, user: any, app: any, showAlert: any) => {
		const data = rowData;
		data.isActive = !data.isActive;

		try {
			const response = await requestDisableConfig(app.appName, { ...data });
			if (response.status !== 200 || !response.data.success) {
				showAlert(response.data.error || 'Error occured while disablin', { type: 'error' });
				return;
			}
			showAlert('Config Disabled');
		} catch (error: any) {
			data.isDisabled = !data.isDisabled;
			showAlert(error.response.data.error || 'Error occured while disabling', { type: 'error' });
		}
	}, []);

	return {
		getCTDConfigData,
		requestUpdateConfig,
		requestCreateConfig,
		toggleIsDisabledField,
		requestDisableGlobalCoolOffFlag,
		isActive,
		setIsActive,
		segmentList,
		expDetailsList
	};
};

export default useService;
